import { CommandGetAffiliates } from "./commands/cmdAffiliates.ts";


export class AccountService {

    async getAffiliates() {
        const cmd = new CommandGetAffiliates();
        const results = cmd.run();
        return results;
    }
   
}
